import { useApplyChangeEvents } from '@nx-frontend/shared/hooks/useChangeEvents';
import { ChangeEventType } from '@nx-frontend/shared/types';
import {
  MenuType,
  PortalProcessData,
  PortalProcessDataStatus,
  PortalProcessItem,
  PortalProcessMenuItem,
} from '@nx-frontend/shared/types/menu';
import { calcProcessData } from '@nx-frontend/shared/utils';

interface ChangeProcessStepStatusProps {
  menuType: MenuType;
  processItem: PortalProcessMenuItem;
  newStatus: PortalProcessDataStatus;
  newItems: PortalProcessItem[];
  publish?: boolean;
}

export const useChangeProcessStatus = (): ((props: ChangeProcessStepStatusProps) => Promise<PortalProcessData>) => {
  const applyChangeEvents = useApplyChangeEvents();

  return async ({ menuType, processItem, newStatus, newItems, publish }) => {
    const process = calcProcessData({
      items: newItems,
      status: newStatus,
      sequential: processItem.process.sequential,
    });

    await applyChangeEvents({
      events: [
        {
          type: ChangeEventType.UPDATE_MENU_ITEM,
          oldValue: { menuType, item: processItem },
          newValue: {
            menuType,
            item: { ...processItem, process, ...(process.status === 'done' ? { icon: 'process_done' } : null) },
          },
        },
      ],
      publish,
    });

    return process;
  };
};
